export default "__VITE_ASSET__$SsnwvZe__"